import React, { useEffect, useState } from "react";
import { Grid } from "@material-ui/core";
import { Alert, AlertTitle } from "@material-ui/lab";

import { useControlForm } from "../../../features/forms/forms.hook";

import { GreenButton } from "../../form-controls/button/green-button/green-button.component";
import { OutlinedButton } from "../../form-controls/button/outlined-button/outlined-button.component";

import { ModalTemplate } from "../modal-template/modal-template.component";

import { FormModalProps } from "./form-modal.props";
import { IFormValues } from "./form-modal.types";
import { useFormModalStyles } from "./form-modal.styles";

export const FormModal = (props: FormModalProps) => {
  const { isOpen, modalErrors } = props;

  const classes = useFormModalStyles();
  const [disabled, setDisabled] = useState<boolean>(false);

  const form = useControlForm({
    defaultValues: props.defaultValues,
    validationRules: props.formValidation,
  });

  useEffect(() => {
    if (isOpen) {
      form.reset();
      setDisabled(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  useEffect(() => {
    setDisabled(false);
    modalErrors?.fieldErrors?.forEach((field) =>
      form.setError(
        field.fieldName,
        { type: "custom", message: field.errorMessage },
        { shouldFocus: true }
      )
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalErrors]);

  const handleCloseModal = () => {
    form.reset();
    props.onClose();
    setDisabled(false);
  };

  const onSubmit = (data: IFormValues) => {
    if (!props.disabled || disabled) {
      setDisabled(true);
      props.submit(data);
    }
  };

  return (
    <ModalTemplate
      header={props.modalTitle}
      closeModal={handleCloseModal}
      open={props.isOpen}
      size="small"
    >
      <Grid item xs={12}>
        {modalErrors?.errorMessage && (
          <Alert className={classes.alert} severity="error">
            <AlertTitle>Error</AlertTitle>
            {modalErrors.errorMessage}
          </Alert>
        )}
        <props.Form errors={form.formState.errors} form={form} />
      </Grid>
      <Grid item xs={12} className="text-right">
        <div className="form-group buttons" style={{ marginTop: "16px" }}>
          <OutlinedButton type="submit" onClick={handleCloseModal}>
            Cancel
          </OutlinedButton>
          <GreenButton
            type="submit"
            disabled={props.disabled || disabled}
            onClick={form.handleSubmit(onSubmit)}
          >
            Save
          </GreenButton>
        </div>
      </Grid>
    </ModalTemplate>
  );
};
